import { Box, Link } from "@chakra-ui/react";
import Navbar from "../components/Navbar";

const MAIN_CONTENT_ID = "main-content";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Box>
            <Link
                href={`#${MAIN_CONTENT_ID}`}
                position="fixed"
                top={2}
                left={2}
                zIndex={100}
                px={4}
                py={2}
                bg="white"
                borderRadius="md"
                boxShadow="md"
                transform="translateY(-150%)"
                _focus={{ transform: "translateY(0)" }}
            >
                Skip to content
            </Link>
            <Navbar />
            <main id={MAIN_CONTENT_ID}>
                <Box p={{ base: 2, md: 4 }}>{children}</Box>
            </main>
        </Box>
    );
};

export default MainLayout;
